module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1438c2e4c3d3aa90557.worker.js");
};